import { useApolloClient } from "@apollo/client";
import { FullScreenLoading } from "@mostrans/web-components/components/base/Loading";
import { Button, Grid, Icon } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { CreateOpportunity } from "../../../../GQL/mutations";
import { valueInputJobDescAtoms, valueInputJobRequirementAtoms, valueInputOpportunity } from "../../../../shared/atoms/getValueInputAtoms";
import FormCreate from "./FormCreate";

function ModalCreateOpportunity(props) {
  const [open, setOpen] = useState(false);
  const { fetchAllOpportunity } = props;
  const { title, division_id, description, location_id, job_level } = useRecoilValue(valueInputOpportunity);
  const client = useApolloClient();
  const valueInputRequirementFromAtoms = useRecoilValue(valueInputJobRequirementAtoms);
  const resetInputOpportunity = useResetRecoilState(valueInputOpportunity);
  const resetInputJobDesc = useResetRecoilState(valueInputJobDescAtoms);
  const resetInputRequirement = useResetRecoilState(valueInputJobRequirementAtoms);
  const [isLoading, setIsLoading] = useState(false);
  const [errInput, setErrInput] = useState(false);
  const [errJobReqMsg, setErrJobReqMsg] = useState("");
  const resetValueOpportunity = useResetRecoilState(valueInputOpportunity);

  const handleOpen = () => {
    setOpen(true);
    resetValueOpportunity();
  };

  const handleClose = () => {
    setOpen(false);
    resetInputOpportunity();
    resetInputRequirement();
    setErrJobReqMsg("");
  };

  const submitOpportunity = async () => {
    const inputOpportunity = {
      title: title,
      description: description,
      location_id: location_id,
      division_id: division_id,
      job_level: job_level,
      Requirement: valueInputRequirementFromAtoms,
    };

    valueInputRequirementFromAtoms.map((jobreq) => {
      if (jobreq.job_requirement === "" || jobreq.job_requirement === null) {
        return setErrJobReqMsg("Job Requirement is Required");
      } else {
        setErrJobReqMsg("");
      }
    });

    if (
      title === "" ||
      title === null ||
      description === "" ||
      description === null ||
      location_id === "" ||
      location_id === null ||
      division_id === "" ||
      division_id === null ||
      job_level === "" ||
      job_level === null
    ) {
      return setErrInput(true);
    }

    try {
      setIsLoading(true);
      const response = await CreateOpportunity(client, inputOpportunity);
      if (response.data.createOpportunity.errMsg === "OK") {
        toast.success("Jobs Submited", {
          position: toast.POSITION.TOP_RIGHT,
        });
        resetInputOpportunity();
        resetInputJobDesc();
        resetInputRequirement();
        handleClose();
        fetchAllOpportunity();
        setErrInput(false);
        setErrJobReqMsg("");
      } else {
        toast.error("Submit Failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setErrInput(false);
      }
    } catch (error) {
      alert(error);
      console.log(error);
    }
    setIsLoading(false);
  };
  return (
    <React.Fragment>
      <FullScreenLoading
        show={isLoading}
        backdropProps={{ style: { zIndex: 10000 } }}
      />
      <ToastContainer />
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Post A Job
        <Icon sx={{ ml: 3 }}>add</Icon>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        sx={{ mt: 1 }}
        maxWidth="xl"
      >
        <Grid container>
          <Grid item>
            <DialogTitle>Create A New Job</DialogTitle>
          </Grid>
        </Grid>
        <DialogContent>
          <FormCreate errInput={errInput} errJobReqMsg={errJobReqMsg} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="error">
            Close
          </Button>{" "}
          <Button
            variant="contained"
            onClick={() => submitOpportunity()}
            color="primary"
            type="submit"
          >
            Post
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalCreateOpportunity;
